import { AttachmentWithStatus } from '../../features/invoice/data/model'
import i18n from '../../utils/i18n'

const statusIconMap: Record<
  string,
  { icon: string; color: string } | undefined
> = {
  APPROVED: { icon: 'pi-check-circle', color: 'text-green-500' },
  REJECTED: { icon: 'pi-times-circle', color: 'text-red-500' },
  ERROR: { icon: 'pi-times-circle', color: 'text-red-500' },
}

export const AttachmentStatusBodyTemplate = (
  status: AttachmentWithStatus['Status'],
) => {
  if (!status) return null

  const { t } = i18n

  if (status && statusIconMap.hasOwnProperty(status)) {
    const statusInfo = statusIconMap[status]
    if (statusInfo) {
      return (
        <div className="flex align-items-center">
          <i className={`pi ${statusInfo.icon} ${statusInfo.color} mr-2`}></i>
          {t(`invoice.attachments.table.columns.status.values.${status}`)}
        </div>
      )
    }
  }

  return <>{status}</>
}
